import styled from 'styled-components';

const StyledRevealButton = styled('div')`
	width: 24px;
	height: 43px;
	position: absolute;
	right: 10px;
	bottom: 0;
	cursor: pointer;

	svg {
		width: 100%;
		height: 100%;
	}
`;

export { StyledRevealButton };


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/MultiAppAuthentication/Form/Input/ButtonReveal/styles.ts